
function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

      var $parcel$global = globalThis;
    
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequirec260"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequirec260"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("27Lyk", function(module, exports) {

$parcel$export(module.exports, "register", () => $18c11f3350a906ea$export$6503ec6e8aabbaf, (v) => $18c11f3350a906ea$export$6503ec6e8aabbaf = v);
var $18c11f3350a906ea$export$6503ec6e8aabbaf;
var $18c11f3350a906ea$export$f7ad0328861e2f03;
"use strict";
var $18c11f3350a906ea$var$mapping = new Map();
function $18c11f3350a906ea$var$register(baseUrl, manifest) {
    for(var i = 0; i < manifest.length - 1; i += 2)$18c11f3350a906ea$var$mapping.set(manifest[i], {
        baseUrl: baseUrl,
        path: manifest[i + 1]
    });
}
function $18c11f3350a906ea$var$resolve(id) {
    var resolved = $18c11f3350a906ea$var$mapping.get(id);
    if (resolved == null) throw new Error("Could not resolve bundle with id " + id);
    return new URL(resolved.path, resolved.baseUrl).toString();
}
$18c11f3350a906ea$export$6503ec6e8aabbaf = $18c11f3350a906ea$var$register;
$18c11f3350a906ea$export$f7ad0328861e2f03 = $18c11f3350a906ea$var$resolve;

});

parcelRegister("hb4bE", function(module, exports) {
module.exports = new URL("Icon-star.a3f2bf92.svg", import.meta.url).toString();

});

parcelRegister("JGhco", function(module, exports) {
module.exports = new URL("icon-2.f0864db5.svg", import.meta.url).toString();

});

var $59d111287da6809f$exports = {};

(parcelRequire("27Lyk")).register(new URL("", import.meta.url).toString(), JSON.parse('["2BF4I","index.b38df7cc.js","aKksN","Icon-star.a3f2bf92.svg","eIkw6","icon-1.aab9efc5.svg","eRurN","icon-2.f0864db5.svg","gxBhk","icon-3.1aef766b.svg","jgrKg","index.a2a2b4a2.js"]'));


var $fhN3L = parcelRequire("fhN3L");

var $gdelx = parcelRequire("gdelx");

var $ldYvH = parcelRequire("ldYvH");

var $hb4bE = parcelRequire("hb4bE");
var $2d51edc24fe2dceb$exports = {};
$2d51edc24fe2dceb$exports = new URL("icon-1.aab9efc5.svg", import.meta.url).toString();


parcelRequire("JGhco");
var $83334a5556daef10$exports = {};
$83334a5556daef10$exports = new URL("icon-3.1aef766b.svg", import.meta.url).toString();


const $dad545c909cfec2d$var$results = document.querySelector(".results");
const $dad545c909cfec2d$var$searchInput = document.querySelector("#searchInput");
const $dad545c909cfec2d$var$app = (0, $fhN3L.initializeApp)((0, $ldYvH.firebaseConfig));
const $dad545c909cfec2d$var$db = (0, $gdelx.getDatabase)($dad545c909cfec2d$var$app);
// Make sure Firebase is initialized before using it
console.log("Firebase initialized:", $dad545c909cfec2d$var$app);
//Defining the maximum length of the description
const $dad545c909cfec2d$var$MAX_LENGTH = 350;
async function $dad545c909cfec2d$var$fetchData() {
    const searchValue = $dad545c909cfec2d$var$searchInput.value;
    const response = await fetch(`https://www.omdbapi.com/?apikey=99542785&t=${searchValue}&plot=full`);
    const data = await response.json();
    $dad545c909cfec2d$var$displayData(data);
}
function $dad545c909cfec2d$var$displayData(movie) {
    // Clear previous results
    $dad545c909cfec2d$var$results.innerHTML = "";
    if (movie.Response === "False") {
        $dad545c909cfec2d$var$results.innerHTML = `<p>${movie.Error}</p>`;
        return;
    }
    let movieCard = document.createElement("li");
    movieCard.classList.add("movie-card");
    const truncatedDescription = $dad545c909cfec2d$var$truncateDescription(movie.Plot || "N/A", $dad545c909cfec2d$var$MAX_LENGTH);
    const showReadMore = (movie.Plot || "N/A").length >= $dad545c909cfec2d$var$MAX_LENGTH;
    movieCard.innerHTML = `
  <div class="movie-card__main-container">
    <div class="movie-card__poster-container">
      <img src="${movie.Poster}" alt="${movie.Title} poster" class="movie-card__poster">
    </div>
    <div class="movie-card__container">
      <div class="movie-card__header">
        <p class="movie-card__title">${movie.Title}</p>
        <div class="movie-card__rating">
          <img src="${0, (/*@__PURE__*/$parcel$interopDefault($hb4bE))}" alt="movie ratings" class="movie-card__rating-icon">
          <span class="movie-card__imdb-rating">${movie.imdbRating || "N/A"}</span>
        </div>
      </div>
      <div class="movie-card__info-container">
        <div class="movie-card__info">
          <p class="movie-card__runtime">${movie.Runtime || "N/A"}</p>
          <p class="movie-card__genre">${movie.Genre || "N/A"}</p>
          <div class="movie-card__watchlist">
            <img src="${0, (/*@__PURE__*/$parcel$interopDefault($2d51edc24fe2dceb$exports))}" alt="A button to add the movie to the watchlist" class="movie-card__watchlist-icon" id="buttonAddToWatchList-${movie.imdbID}">
            <span class="buttonAddToWatchList" id="buttonAddToWatchList-${movie.imdbID}">Watchlist</span>
          </div>
        </div>
        <div class="movie-card__description">
          <p class="movie-card__description-text">${truncatedDescription}
          ${showReadMore ? `<button class="movie-card__read-more">Read More</button>` : ""}
          </p>
        </div>
      </div>
    </div>
  </div>
  `;
    //Adding event listener to the watchlist button
    const buttonAddToWatchlist = movieCard.querySelector(`#buttonAddToWatchList-${movie.imdbID}`);
    buttonAddToWatchlist.addEventListener("click", ()=>{
        $dad545c909cfec2d$var$addToWatchList(movie);
    });
    $dad545c909cfec2d$var$results.appendChild(movieCard);
    //Adding event listener to the read more button
    if (showReadMore) {
        const readMoreButton = movieCard.querySelector(".movie-card__read-more");
        readMoreButton.addEventListener("click", ()=>{
            $dad545c909cfec2d$var$toggleDescription(readMoreButton, movie.Plot || "N/A");
        });
    }
}
// Function to truncate the description to the maximum length
function $dad545c909cfec2d$var$truncateDescription(description, maxLength) {
    if (description.length >= maxLength) return description.substring(0, maxLength) + "...";
    return description;
}
//Function to toggle the read more button
function $dad545c909cfec2d$var$toggleDescription(button, fullDescription) {
    const descriptionElement = button.closest(".movie-card__description").querySelector(".movie-card__description-text");
    if (button.textContent === "Read More") {
        descriptionElement.textContent = fullDescription;
        button.textContent = "Show Less";
    } else {
        descriptionElement.textContent = $dad545c909cfec2d$var$truncateDescription(fullDescription, $dad545c909cfec2d$var$MAX_LENGTH);
        button.textContent = "Read More";
    }
}
//Function to add to watchlist
function $dad545c909cfec2d$var$addToWatchList(movie) {
    const movieRef = (0, $gdelx.ref)($dad545c909cfec2d$var$db, "watchlist/" + movie.imdbID);
    (0, $gdelx.set)(movieRef, movie).then(()=>{
        console.log("Movie added to watchlist successfully");
    // Optionally, you can update the UI here to indicate the movie was added
    }).catch((error)=>{
        console.error("Error adding movie to watchlist:", error);
    });
}
//Adding event listener to the search form
document.querySelector(".search-form").addEventListener("submit", function(e) {
    e.preventDefault();
    $dad545c909cfec2d$var$fetchData();
});


//# sourceMappingURL=index.b38df7cc.js.map
